import React, { useImperativeHandle, forwardRef } from 'react';
import cx from 'classnames';

const styles = require('./index.less');

const glitchAniList = [styles.glitch1, styles.glitch2, styles.glitch3];
/**
 * 机兵页面正中间的三个框框
 * @param {*} config
 * @param {*} config.left
 * @param {*} config.center
 * @param {*} config.right
 * @returns
 */
const Block = forwardRef(
  ({ enableGlitch = false, config, className, onClick, onAnimationEnd, onHover, openEntryAnimation, whichActive, disabled, ...rest }, ref) => {
    const [animating, setAnimating] = React.useState(false); // 是否正在播放动画

    const handleClick = item => {
      if (disabled) return;
      if (enableGlitch) {
        if (animating) return;
        setAnimating(true);
        setTimeout(() => {
          setAnimating(false);
          onClick?.(item);
        }, 300);
      } else {
        onClick?.(item);
      }
    };

    useImperativeHandle(ref, () => ({
      onClick: handleClick
    }));

    const renderItem = (which, cfg) => {
      return (
        <div className={cx(styles[which], whichActive === which && styles.leftActive)} onClick={() => handleClick(cfg)} onMouseEnter={() => onHover?.(cfg)}>
          <div className={cx(styles.inner, styles.background)}>
            <img className={styles.normal} src={cfg?.normal} alt={cfg?.name} />
          </div>
          <div className={cx(styles.inner, animating && glitchAniList[Math.round(Math.random() * (glitchAniList.length - 1))])}>
            <img className={styles.normal} src={cfg?.normal} alt={cfg?.name} />
            {cfg?.hover && <img className={styles.hover} src={cfg?.hover} alt={cfg?.name} />}
          </div>
        </div>
      );
    };

    return (
      <div className={cx(styles.block, openEntryAnimation && styles.entryAnimation, className)} {...rest}>
        {renderItem('left', config.left)}
        {config.center && renderItem('center', config.center)}
        {renderItem('right', config.right)}
      </div>
    );
  }
);

Block.defaultProps = {
  openEntryAnimation: false
};

export default Block;
